import { keepPreviousData, useQuery } from '@tanstack/react-query';

import getHostStockList from 'Api/host-stock-promo/getHostStockList';
import { useHostStockPromoState } from 'View/host-stock-promo/state';

import getHostStockListRequest from './model/request/getHostStockListRequest';
import getHostStockListResponse from './model/response/getHostStockListResponse';

const useGetHostStockList = ({ params, enabled }) => {
  const { state, updateState } = useHostStockPromoState();

  return useQuery({
    queryKey: ['host-stock-list', params],
    queryFn: async () => {
      const queries = getHostStockListRequest(params);

      const response = await getHostStockList(queries);

      const result = getHostStockListResponse(response, state.previousStocks, params?.page);

      updateState({ previousStocks: result?.stocks });

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled,
    placeholderData: keepPreviousData,
  });
};

export default useGetHostStockList;
